import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, tap } from 'rxjs';
import { API_ENDPOINTS } from 'src/app/core/constants/api-endpoints.constant';
import { environment } from 'src/environments/environment';
import { PaginationOptions } from 'src/app/core/interfaces/pagination-options';
import { ServerResponse } from 'src/app/core/interfaces/server.interface';

const baseUrl = environment.baseUrl;

@Injectable({
    providedIn: 'root'
})
export class DashboardService {

    private http = inject(HttpClient);

    getPendingBranch(options: PaginationOptions): Observable<ServerResponse> {
        const { status, from, to, per_page = 10, page } = options;
        const params: any = { per_page };

        if (status !== undefined) params.status = status;
        if (from !== undefined) params.from = from;
        if (to !== undefined) params.to = to;
        if (page !== undefined) params.page = page;

        return this.http.get<ServerResponse>(`${baseUrl}${API_ENDPOINTS.GET_PEDING_BRANCHES_TODAY}`, { params })
        // .pipe(tap((resp) => console.log(resp)));
    }


    branchesCount(): Observable<ServerResponse<number | null>> {
        return this.http.get<ServerResponse>(`${baseUrl}${API_ENDPOINTS.BRANCHES_COUNT}`)
    }

}
